import Text from '../formElements/Text';
import Hidden from '../formElements/Hidden';
import Phone from '../formElements/Phone';
import RSTextarea from '../formElements/RSTextarea';
import Number from '../formElements/Number';
import RSSelect from '../formElements/RSSelect/index.js';
import Bullets from '../formElements/Bullets';
import RSRadio from '../formElements/RSRadio';
import Checkboxes from '../formElements/Checkboxes/index.js';
import ResumeTemplateChooser from '../formSections/TemplateChooser';
import AdvancedSelect from '../formElements/AdvancedSelect/index.js';
import Expertise from '../formElements/Expertise/index';
import Multipart from '../formElements/Multipart';
import { Box, GridItem } from '@chakra-ui/react';
import ProTip from '../formElements/components/ProTip';
import QuestionTemplate from '../components/Wrappers/QuestionTemplate';
import WideQuestionTemplate from '../components/Wrappers/WideQuestionTemplate';
import ComputerSkills from '../formElements/ComputerSkills';
import RSAI from '../formElements/RSAI';
import RSFileUpload from '../formElements/RSFileUpload';
import ParserRadio from '../formSections/Parser/ParserRadio';
import Display from '../formElements/Display';
import RSTextareaVideo from '../formSections/Interview/RSTextareaVideo';
import { getUsefulVars } from '../handlers/helpers';
import { set_ai_opts } from '../formElements/RSAI/utils';
import RSVideoUpload from '../formSections/Interview/coach/RSVideoUpload';

export const getQuestionTemplateByQuestionType = (props, qObj, index, isMultipart = false) => {
  //find SingleSection

  const fieldName = `jobSeekerData[${index}]["${qObj.qid}"]`;
  const jobSeekerData = props.formikProps.values.jobSeekerData;
  const handlers = props.handlers;
  const styles = props.stateProps.elementsStyles;
  const returnInput = function() {
    return (
      <Text fieldName={fieldName} qObj={qObj} jobSeekerData={jobSeekerData} handlers={handlers} props={props}
            index={index} />
    );
  };
  const returnHidden = function() {
    return (<Hidden fieldName={fieldName} />);
  };
  const returnPhone = function() {
    return (<Phone fieldName={fieldName} qObj={qObj} jobSeekerData={jobSeekerData} handler={handlers} props={props}
                   index={index}></Phone>);
  };
  const returnDisplay = function () {
    return (
      <Display fieldName={fieldName} qObj={qObj} jobSeekerData={jobSeekerData} handlers={handlers} props={props}
            index={index} />
    );

  }
  const returnTextarea = function() {
    return (<RSTextarea qObj={qObj} props={props} resumeIndex={null}  />);
  };
  const returnTextareaVideo = function() {
    return (<RSTextareaVideo fieldName={fieldName} qObj={qObj} jobSeekerData={jobSeekerData} props={props} index={index} />);
  };
  const returnVideoUpload = function() {
    return (<RSVideoUpload  props={props}  /> );
  };
  const returnFileUpload = function() {
    return (
      <RSFileUpload fieldName={fieldName} qObj={qObj} jobSeekerData={jobSeekerData} handlers={handlers} props={props}
                    index={index} />);

  };
  const returnNumber = function() {
    return (<Number fieldName={fieldName} qObj={qObj} props={props} index={index} />);

  };
  const returnSelect = function() {
    return (
      <RSSelect fieldName={fieldName} qObj={qObj} props={props} index={index} />
    );
  };
  const returnBullets = function() {
    return Bullets(fieldName, qObj, props, jobSeekerData, false);
  };
  const returnMultiSelect = function() {
    //return ()RSSelect(fieldName, qObj, true);
  };
  const returnRadio = function() {
    //ALERT shameless hack.  need to separate parser radio into a separate input type in RSForm
    if (qObj.qid==='P1') {
      return (
        <ParserRadio fieldName={fieldName} qObj={qObj} props={props} styles={styles} />
      );
    } else {
      return (
        <RSRadio fieldName={fieldName} qObj={qObj} props={props} styles={styles} />
      );
    }
  };
  const returnCheckboxes = function() {
    return (
      <Checkboxes fieldName={fieldName} qObj={qObj} props={props} />
    );
  };
  const templateSelect = function() {
    return ResumeTemplateChooser(
      qObj,
      fieldName,
      props,
      index,
      styles,
    );
  };
  const returnAdvancedSelect = function() {
    return (
      AdvancedSelect(
        {
          fieldName,
          qObj,
          props,
          index,
        },
      )
    );
  };
  const returnComputerSkills = function() {
    qObj.stateProps = props.stateProps;
    const industryName = props.stateProps.sectionData.resumeIndustryName;
    if (industryName !== '') {
      return (
        <ComputerSkills qObj={qObj} fieldName={fieldName} props={props} />
      );
    } else {
      return null;
    }
  };
  const returnExpertise = function() {
    qObj.stateProps = props.stateProps;
    const resumeIndex = props.stateProps.sectionData.resumeIndex;
    const industryName = props.stateProps.dataToSave.saved.resumes[resumeIndex].industry[0];
    if (industryName !== '') {
      let industry = props.survey.industry[industryName];
      if (!industry) {
        industry = props.survey.industry['other'];
      }
      industry = { slug: 'other' };//industryName;
      return (
        <Expertise industry="other" qObj={qObj} fieldName={fieldName} props={props} />
      );
    } else {
      return null;
    }
  };
  const multipart = function() {
    return (<Multipart props={props} qObj={qObj} index={index} fieldName={fieldName} />);

  };
  const returnAI = function() {
   //return null;
    const uv=getUsefulVars(props);
    const callbackArgs = {
      fieldName:fieldName,
      qObj:qObj,
      props:props,
      styles:styles
    }
    if(!uv.resume.regenCS) {
      set_ai_opts(props,qObj,callbackArgs);
    } else {
      return (<RSAI fieldName={fieldName} qObj={qObj} props={props} styles={styles} />);
    }
    };
  const qTypes = {
    hidden: returnHidden,
    display: returnDisplay,
    text: returnInput,
    email: returnInput,
    file: returnFileUpload,
    phone: returnPhone,
    currency: returnInput,
    textarea: returnTextarea,
    textarea_video: returnTextareaVideo,
    video_upload:returnVideoUpload,
    number: returnNumber,
    radio: returnRadio,
    checkboxes: returnCheckboxes,
    select: returnSelect,
    bullets: returnBullets,
    numberlist: returnSelect,
    multiselect: returnMultiSelect,
    //industries: returnIndustries,
    //industries_and_aliases: returnIndustries,
    //optionSelect: returnSelect,
    optionSelect: returnAdvancedSelect,
    expertise: returnExpertise,
    computerskills: returnComputerSkills,
    docupilot: templateSelect,
    multipart: multipart,
    multipart_revenue: returnInput,
    ai: returnAI,
  };
  if (typeof qTypes[qObj.question_type] !== 'undefined') {
    if (isMultipart) {
      return (
        <GridItem position="relative" >
          <Box display='flex' width='100%'>
            <Box width='100%'>{qTypes[qObj.question_type]()}</Box>
          <ProTip proTip={qObj.expanded_instructions} variant="question" stateProps={props.stateProps} />
          </Box>
        </GridItem>
      );
    } else {
      return (
        <GridItem>
          {(qObj.question_type === 'expertise' || qObj.question_type === 'bullets' || qObj.question_type === 'docupilot' || qObj.qid === 'CS1') ? (
            <WideQuestionTemplate position="relative">
              <ProTip proTip={qObj.expanded_instructions} variant="question" stateProps={props.stateProps} />
              {qTypes[qObj.question_type]()}
            </WideQuestionTemplate>
          ) : (
            <QuestionTemplate props={props}>
              <Box>
                {qTypes[qObj.question_type]()}
              </Box>
            </QuestionTemplate>

          )}


        </GridItem>
      );
    }

  } else {
    return null;
  }
};

